(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-skincare-presentation"] && !Shopify.designMode) return;
  try {
    

(() => {
  const initialize = () => {
    const config = document.querySelector('[data-av-skincare]');
    const product = document.querySelector('.product-o2o');
    const form = product?.querySelector('form.product-form');
    if (!config || !form || form.dataset.avInitialized) return;
    form.dataset.avInitialized = 'true';
    form.querySelectorAll('.single-option-radio input').forEach(input => { const label = input.nextElementSibling; if (label?.tagName === 'LABEL' && !label.textContent.trim()) label.textContent = input.value; });
    const shadeGuide = document.getElementById('AvShadeGuide');
    if(shadeGuide){
      let shadeGroup;
      form.querySelectorAll('.single-option-radio input').forEach(input=>{
        const source=Array.from(shadeGuide.content.querySelectorAll('[data-shade]')).find(item=>item.dataset.shade===input.value);
        const label=input.nextElementSibling;
        if(!source || label?.tagName!=='LABEL')return;
        shadeGroup=input.closest('.selector-wrapper');
        label.classList.add('av-shade-card');
        label.dataset.tone=source.dataset.tone;
        const swatch=document.createElement('span');swatch.className='av-shade-swatch';swatch.setAttribute('aria-hidden','true');
        const copy=document.createElement('span');copy.className='av-shade-copy';
        const name=document.createElement('strong');name.textContent=input.value;
        const detail=document.createElement('small');detail.textContent=source.textContent;
        copy.append(name,detail);label.replaceChildren(swatch,copy);
      });
      if(shadeGroup){
        const heading=shadeGroup.querySelector(':scope > label');if(heading)heading.textContent=shadeGuide.content.querySelector('[data-shade-heading]').textContent;
        const note=shadeGuide.content.querySelector('[data-shade-note]').cloneNode(true);note.className='av-shade-note';shadeGroup.append(note);
      }
    }
    const variants = JSON.parse(document.getElementById('AvSkincareVariants').textContent);
    const stock = JSON.parse(document.getElementById('AvSkincareStock').textContent);
    const wrapper = product.querySelector('.product-single__info-wrapper');
    const panel = document.getElementById('AvPurchaseTemplate').content.cloneNode(true);
    const getQuantity = () => form.querySelector('[name="quantity"]');
    const quantityWrapper = form.querySelector('.product-form__item--quantity');
    const cartButton = form.querySelector('.product-form__cart-submit');
    const cartWrapper = cartButton?.closest('.product-form__item--submit');
    form.prepend(panel);
    const purchase = form.querySelector('.av-purchase-panel');
    const existingControls = form.querySelector('.product-form__quantity-submit');
    existingControls.before(purchase);
    if (quantityWrapper) purchase.querySelector('.av-quantity-custom').append(quantityWrapper);
    if (cartWrapper) purchase.querySelector('[data-av-cart-slot]').append(cartWrapper);
    const types = config.querySelector('.av-skin-types');
    if (types) form.prepend(types);
    wrapper.append(document.getElementById('AvFaqTemplate').content.cloneNode(true));
    const details = wrapper.querySelector('[data-av-product-details]');
    wrapper.querySelectorAll('.short-description,.product-single__description').forEach(copy => { if (copy.textContent.trim()) { details.querySelector('.av-product-copy').append(copy); details.hidden = false; } });
    document.body.append(document.getElementById('AvStickyTemplate').content.cloneNode(true));
    const sticky = document.querySelector('.av-mobile-purchase');
    const color = config.style.getPropertyValue('--av-red');
    purchase.style.setProperty('--av-red',color);
    sticky.style.setProperty('--av-red',color);
    const buttons = [purchase.querySelector('[data-av-buy]'),sticky.querySelector('[data-av-buy]')];
    const money = value => config.dataset.currency === 'MYR' ? 'RM' + new Intl.NumberFormat('en-MY',{minimumFractionDigits:value % 100 ? 2 : 0,maximumFractionDigits:2}).format(value / 100) : new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:config.dataset.currency || 'MYR'}).format(value / 100);
    const write = (el,text) => { if (el && el.textContent !== text) el.textContent = text; };
    const resolveVariant = () => {
      const options = Array.from(form.querySelectorAll('.selector-wrapper')).map(group => group.querySelector('input:checked,select')?.value);
      return options.length ? variants.find(v => options.every((option,i) => v.options[i] === option)) : variants[0];
    };
    const manual = purchase.querySelector('[data-av-manual]');
    const region = purchase.querySelector('[data-av-region]');
    const deliveryUpdate = () => {
      const parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Kuala_Lumpur',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
      const val = type => Number(parts.find(p => p.type === type).value);
      const now = new Date(Date.UTC(val('year'),val('month')-1,val('day'),val('hour'),val('minute'),val('second')));
      const cutoff = new Date(now); cutoff.setUTCHours(14,0,0,0);
      const extraDay = now >= cutoff ? 1 : 0;
      cutoff.setUTCDate(cutoff.getUTCDate()+extraDay);
      const minutes = Math.max(0,Math.floor((cutoff-now)/60000));
      const dateAfter = days => { const date = new Date(now);date.setUTCDate(date.getUTCDate()+days);return new Intl.DateTimeFormat('en-GB',{weekday:'short',day:'numeric',month:'short',timeZone:'UTC'}).format(date); };
      const range = {wm:[1,3],em:[3,7],intl:[7,14]}[region.value];
      write(purchase.querySelector('[data-av-arrival]'),dateAfter(range[0]+extraDay)+' – '+dateAfter(range[1]+extraDay));
      write(purchase.querySelector('[data-av-dispatch]'),dateAfter(extraDay));
      write(purchase.querySelector('[data-av-countdown]'),Math.floor(minutes/60)+' hrs '+(minutes%60)+' min');
    };
    region.addEventListener('change',deliveryUpdate);
    deliveryUpdate();
    const deliveryTimer = window.setInterval(()=>{if(!purchase.isConnected){clearInterval(deliveryTimer);return;}deliveryUpdate();},60000);
    let busy = false;
    const update = () => {
      const variant = resolveVariant();
      const maximum = stock[String(variant?.id)];
      const qty = Math.min(maximum === null || maximum === undefined ? Infinity : Math.max(1,maximum),Math.max(1,Math.floor(Number(getQuantity()?.value) || 1)));
      if(getQuantity()) getQuantity().value = String(qty);
      if(document.activeElement !== manual) manual.value = String(qty);
      if(maximum === null || maximum === undefined) manual.removeAttribute('max'); else manual.max = String(Math.max(1,maximum));
      purchase.querySelector('[data-av-step="-1"]').disabled = qty <= 1;
      purchase.querySelector('[data-av-step="1"]').disabled = maximum !== null && maximum !== undefined && qty >= maximum;
      const currency = config.dataset.currency;
      const tiers = [];
      const app = form.querySelector('.aiod-volume-discount-wrap');
      let validRows = true;
      if (app && currency === 'MYR') app.querySelectorAll('tbody tr').forEach(row => {
        const cells = row.querySelectorAll('td');
        const minimum = cells[0]?.textContent.match(/^\s*Buy\s+(\d+)\s*\+/i);
        const amount = cells[1]?.textContent.match(/^\s*Get each product for\s+(?:MYR|RM)\s*([\d,]+\.\d{2})(?:\s*MYR)?\s*$/i);
        if (minimum && amount) tiers.push({min:Number(minimum[1]),price:Math.round(Number(amount[1].replaceAll(',','')) * 100)});
        else validRows = false;
      });
      tiers.sort((a,b) => a.min-b.min);
      const usableTiers = validRows ? tiers : [];
      const unit = count => usableTiers.filter(t => t.min <= count).at(-1)?.price ?? variant?.price ?? 0;
      app?.classList.toggle('av-tiers-integrated',usableTiers.length > 0);
      purchase.querySelectorAll('[data-av-quantity]').forEach(button => {
        const count = Number(button.dataset.avQuantity);
        button.setAttribute('aria-pressed',String(qty === count));
        button.disabled = !variant?.available || (maximum !== null && maximum !== undefined && count > maximum);
        write(button.querySelector('[data-av-tier]'), variant ? money(unit(count)*count) : '—');
      });
      document.querySelectorAll('[data-av-total]').forEach(el => write(el,variant ? money(unit(qty)*qty) : '—'));
      write(sticky.querySelector('[data-av-selection]'),[variant?.public_title, '× '+qty].filter(Boolean).join(' · '));
      buttons.forEach(button => {
        button.disabled = busy || !variant?.available;
        write(button.querySelector('span'), variant?.available ? config.dataset.buy : config.dataset.sold);
      });
      const url = new URL(window.location.href);
      url.searchParams.set('view','skincare-preview');
      if (variant) url.searchParams.set('variant',variant.id);
      window.history.replaceState(window.history.state,'',url);
    };
    let frame;
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    purchase.querySelectorAll('[data-av-quantity]').forEach(button => button.addEventListener('click',() => {
      const quantity = getQuantity();
      if (!quantity) return;
      quantity.value = button.dataset.avQuantity;
      quantity.dispatchEvent(new Event('change',{bubbles:true}));
      schedule();
    }));
    const setManual = value => { const quantity=getQuantity(); if(!quantity)return; const max=Number(manual.max)||Infinity; quantity.value=String(Math.min(max,Math.max(1,Math.floor(Number(value)||1)))); manual.value=quantity.value;quantity.dispatchEvent(new Event('change',{bubbles:true}));schedule(); };
    manual.addEventListener('input',()=>{if(manual.value!=='' && manual.validity.valid)setManual(manual.value);});
    manual.addEventListener('change',()=>setManual(manual.value));
    manual.addEventListener('blur',()=>setManual(manual.value));
    purchase.querySelectorAll('[data-av-step]').forEach(button=>button.addEventListener('click',()=>setManual(Number(getQuantity()?.value||1)+Number(button.dataset.avStep))));
    form.addEventListener('change',schedule);
    form.addEventListener('input',schedule);
    form.addEventListener('click',schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(form,{childList:true,subtree:true,characterData:true});
    buttons.forEach(button => button.addEventListener('click',async () => {
      if (busy) return;
      const variant = resolveVariant();
      if (!variant?.available || !form.reportValidity()) return;
      const error = purchase.querySelector('.av-purchase-error');
      error.hidden = true;
      busy = true;
      update();
      try {
        const checkout = purchase.querySelector('[data-av-checkout]');
        checkout.classList.remove('aiod_cart_loaded');
        const body = new FormData(form);
        body.set('id',String(variant.id));
        body.set('quantity',String(Math.max(1,Math.floor(Number(getQuantity()?.value) || 1))));
        const response = await fetch(config.dataset.addUrl,{method:'POST',body,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || config.dataset.error);
        if (typeof window.csappsCheckout === 'function') {
          const ready = await new Promise(resolve => {
            if (checkout.classList.contains('aiod_cart_loaded')) return resolve(true);
            const watch = new MutationObserver(() => {
              if (checkout.classList.contains('aiod_cart_loaded')) { watch.disconnect(); clearTimeout(timeout); resolve(true); }
            });
            const timeout = setTimeout(() => { watch.disconnect(); resolve(false); },12000);
            watch.observe(checkout,{attributes:true,attributeFilter:['class']});
          });
          if (!ready) { window.location.assign(config.dataset.cartUrl); return; }
          checkout.click();
          window.setTimeout(() => window.location.assign(config.dataset.cartUrl),15000);
        } else window.location.assign(config.dataset.cartUrl);
      } catch (failure) {
        write(error,failure.message || config.dataset.error);
        error.hidden = false;
        error.scrollIntoView({block:'center',behavior:'smooth'});
        busy = false;
        update();
      }
    }));
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
  
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
  
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
  
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
  
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
              if (window.SPR && theme.review ) {
                if ($('.shopify-product-reviews-badge').length > 0) {
                  return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                };
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
  
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
      }
    }
  
    customElements.define('product-recommendations', ProductRecommendations);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("s-timeline__img--bounce-in"),t.contents[e].classList.add("s-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-s-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
